<div class="card h-100">
  <div class="card-header d-flex justify-content-between align-items-center border-0 bg-transparent p-3">
    <div>
      <h5 class="card-title mb-0 d-flex align-items-center gap-2">
        Top 10 MTTD Detections
        <kendo-svg-icon
          [icon]="infoCircleIcon"
          size="small"
          class="info-icon"
          kendoTooltip
          title="Highlights the top 10 detection types with the highest mean time to detect, helping identify where detection speed can be improved."
        ></kendo-svg-icon>
      </h5>
      <p class="text-muted small mb-0">Mean Time to Detect by Detection Type</p>
    </div>
    <kendo-dropdownbutton
      kendoButton
      [svgIcon]="moreVerticalIcon"
      fillMode="flat"
      size="small"
      [data]="[{ text: 'View Data' }]"
      (itemClick)="onContextMenuSelect({ text: 'View Alert Data' })"
    ></kendo-dropdownbutton>
  </div>
  <div class="card-body p-0">
    <div class="list-group list-group-flush">
      @for (detection of formattedDetections(); track detection.detection_name) {
        <div class="list-group-item d-flex justify-content-between align-items-center py-2 px-3">
          <span class="text-truncate me-2">{{ detection.detection_name }}</span>
          <span
            class="badge"
            [class]="'bg-' + getMttdSeverity(detection.mttd)"
          >
            {{ detection.formattedMttd }}
          </span>
        </div>
      }
    </div>
  </div>
</div>

<!-- Reusable Alert Data Dialog -->
@if (alertDialogConfig()) {
  <app-alert-data-dialog
    [config]="alertDialogConfig()!"
    [visible]="showAlertDialog()"
    (close)="onAlertDialogClose()"
    (exportCsv)="triggerExport()"
  />
}
